'use strict';

const zIndexes = {
  menu: 1000,
};

module.exports = {
  zIndexes,
};
